"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _client = require("@searchkit/client");

var _react = _interopRequireDefault(require("react"));

var _FormikWrapper = _interopRequireDefault(require("../../Form/FormikWrapper"));

var _Select = _interopRequireDefault(require("../../Form/Select"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var useInitialValues = function useInitialValues() {
  var parsed = (0, _client.useSearchkitVariables)();
  return {
    'sortBy': parsed.sortBy
  };
};

var SearchSorting = function SearchSorting(_ref) {
  var _data$results, _data$results$summary, _data$results$summary2;

  var data = _ref.data,
      loading = _ref.loading;
  var api = (0, _client.useSearchkit)();
  var initialValues = useInitialValues();
  var options = (data === null || data === void 0 ? void 0 : (_data$results = data.results) === null || _data$results === void 0 ? void 0 : (_data$results$summary = _data$results.summary) === null || _data$results$summary === void 0 ? void 0 : (_data$results$summary2 = _data$results$summary.sortOptions) === null || _data$results$summary2 === void 0 ? void 0 : _data$results$summary2.map(function (sortOption) {
    return {
      value: sortOption.id,
      label: sortOption.label
    };
  })) || [];
  return /*#__PURE__*/_react.default.createElement(_FormikWrapper.default, {
    initialValues: initialValues
  }, /*#__PURE__*/_react.default.createElement(_Select.default, {
    fieldName: "sortBy",
    isClearable: false,
    isSearchable: false,
    options: options,
    isLoading: loading,
    onChange: function onChange(value) {
      api.setSortBy(value);
      api.setPage({
        from: 0
      });
      api.search();
    }
  }));
};

var _default = SearchSorting;
exports.default = _default;